module.exports = __webpack_public_path__ + "img/GVC003.c9d1adf4.png";